const FontsFamiliesFoundationsThemes = {
    font_family_heading: 'Noto Sans',
    font_family_paragraph: 'Noto Sans',
};
export { FontsFamiliesFoundationsThemes };
//# sourceMappingURL=fonts-families-foundations.themes.js.map